module.exports = __webpack_public_path__ + "static/img/month.ae96f67f.svg";